<div
  *ngIf="currentOrder$ | async as currentOrder; else loading"
  class="overflow-auto-height-100-padding-top-60 bg-white pt-8"
>
  <ng-container *ngIf="isViewing$ | async">
    <a
      mat-icon-button
      aria-label="Back to order list"
      [routerLink]="backUrl$ | async"
      saAutomatedSelector="lmo_order_details__back_to_list"
    >
      <mat-icon>arrow_back</mat-icon>
    </a>
    <div class="info-container">
      <h2 mat-dialog-title>
        {{ currentOrder.saUniqueId }}<br />
        <span class="sub-header" saAutomatedSelector="lmo_order_details__load_number"
          >Sequence Number: {{ currentOrder.loadNumber }}</span
        >
      </h2>
      <div class="pb-2" *ngIf="currentOrder.replacedByOrderId">
        This order was canceled and replaced with {{ currentOrder.replacedByOrderId | orderId }}
      </div>
      <div class="name-wrap">{{ currentOrder.vendor.name }}</div>
      <div class="name-detail">{{ currentOrder.loadWeight / 1000 }}k of {{ currentOrder.mesh.type }} mesh</div>
      <div class="name-detail">PO Number {{ currentOrder.poNumber }}</div>
      <div *ngIf="currentOrder.trailerType" class="name-detail capitalize">
        Trailer Type : {{ currentOrder.trailerType?.trailerTypeName }}
      </div>
      <div class="route-desc">
        <div class="end-point">
          <div *ngIf="currentOrder.boxPickup && currentOrder.boxPickup?.beforeOrder; then boxMove"></div>
        </div>
        <div class="end-point" *ngIf="currentOrder.mine?.id">
          <div
            class="icon-wrap"
            [class.traveling-to]="
              !isFinished(currentOrder) &&
              isDriverAccepted(currentOrder) &&
              !currentOrder.loaded &&
              !currentOrder.pendingBoxPickup
            "
          >
            <i class="material-icons">arrow_upward</i>
          </div>
          <span>{{ currentOrder.mine?.site?.name }}</span>
        </div>
        <div class="end-point" *ngIf="currentOrder.distributionCenter?.id">
          <div
            class="icon-wrap"
            [class.traveling-to]="
              !isFinished(currentOrder) &&
              isDriverAccepted(currentOrder) &&
              !currentOrder.loaded &&
              !currentOrder.pendingBoxPickup
            "
          >
            <i class="material-icons">arrow_upward</i>
          </div>
          <span>(DC) {{ currentOrder.distributionCenter?.site?.name }}</span>
        </div>
        <div class="end-point">
          <div
            class="icon-wrap"
            [class.traveling-to]="
              !isFinished(currentOrder) &&
              isDriverAccepted(currentOrder) &&
              currentOrder.loaded &&
              !currentOrder.pendingBoxPickup
            "
          >
            <i class="material-icons">arrow_downward</i>
          </div>
          <span>{{ currentOrder.jobName }}</span>
          <ng-template #fracNameLoading>
            <mat-spinner diameter="15"></mat-spinner>
          </ng-template>
        </div>
        <div class="end-point">
          <div *ngIf="currentOrder.boxPickup && !currentOrder.boxPickup?.beforeOrder; then boxMove"></div>
        </div>
        <ng-template #boxMove>
          <div
            class="icon-wrap flex items-center justify-center"
            [class.traveling-to]="
              !isFinished(currentOrder) && !currentOrder.boxPickup?.completed && currentOrder.pendingBoxPickup
            "
          >
            <img
              class="w-2"
              src="/assets/icons/box_move_light.svg"
              alt="box move"
              matTooltip="Box Move {{ currentOrder.boxPickup?.siteName }}"
            />
          </div>
          <span>(BOX PICKUP) {{ currentOrder.boxPickup?.siteName }}</span>
        </ng-template>
      </div>
      <div class="action-bar"></div>
      <div class="time-bar" *ngIf="isCompleteGroup(currentOrder)">
        Completed at {{ currentOrder.endTimestamp | date: 'H:mm LLL dd' }}
      </div>
      <ng-container *saAllowedAccountRoles="[1, 2, 9, 10]">
        <div class="button-row" *ngIf="!isCompleteGroup(currentOrder)">
          <ng-container *ngIf="currentOrder.cannotCancel; else canCancel">
            <div
              class="opacity-50 cursor-not-allowed"
              matTooltip="This load has already been picked up and cannot be cancelled."
            >
              Cancel
            </div>
          </ng-container>
          <ng-template #canCancel>
            <a
              mat-stroked-button
              color="warn"
              [routerLink]="['./']"
              [queryParams]="{ state: 'cancel' }"
              saAutomatedSelector="lmo_order_details__cancel_button"
            >
              Cancel
            </a>
          </ng-template>
          <a
            mat-stroked-button
            *ngIf="(canReassign$ | async) && isPendingGroup(currentOrder)"
            color="primary"
            [routerLink]="['./']"
            [queryParams]="{ state: 'reassign' }"
            saAutomatedSelector="lmo_order_details__reassign_button"
          >
            Reassign Vendor
          </a>
          <div>
            <button
              mat-raised-button
              *ngIf="currentOrder.loaded"
              [routerLink]="['./']"
              [queryParams]="{ state: 'diverted' }"
            >
              Divert
            </button>
          </div>
          <a
            mat-raised-button
            *ngIf="isDriverAccepted(currentOrder)"
            [routerLink]="['./']"
            [queryParams]="{ state: 'complete' }"
          >
            Complete
          </a>
        </div>
      </ng-container>
    </div>
    <div class="info-container" *ngIf="currentOrder.user && isInProgressGroup(currentOrder)">
      <div class="head-wrap">
        <h3>Current Status</h3>
        <div class="timestamp">
          Updated {{ currentOrder.user?.lastTimeSeen | ago }}
          <br />
          <span class="preload" *ngIf="currentOrder.isPreLoad">PreLoad</span>
        </div>
      </div>
      <div class="sub-content-wrap">
        <div class="main-content">
          <div class="name-wrap">{{ currentOrder.user?.name }}</div>
          <div class="name-detail" *ngIf="currentOrder.classicSubcontractorName">
            ({{ currentOrder.classicSubcontractorName }})
          </div>
          <div class="name-detail">Truck {{ currentOrder.truck?.name }}</div>
          <div class="name-detail" *ngIf="currentOrder?.trailer">Trailer {{ currentOrder.trailer?.name }}</div>
          <div class="name-wrap" style="margin-top: 8px;">PO Number {{ currentOrder.poNumber }}</div>
          <div *saFeatureFlag="'orderTrailerType'">
            <div *ngIf="currentOrder.trailerType" class="name-detail">
              Trailer Type : {{ currentOrder.trailerType?.trailerTypeDisplayName }}
            </div>
          </div>
        </div>
        <div class="time-details">
          <ng-container *ngIf="isUnreachable(currentOrder.user?.userStatus) || isOnline(currentOrder.user?.userStatus)">
            <div class="timestamp">
              <span *ngIf="isEtaArrived(currentOrder)">ARRIVED</span>
              <span *ngIf="isEtaStaging(currentOrder)">STAGING</span>
              <span *ngIf="isEtaNone(currentOrder)">{{ currentOrder?.eta | eta }}</span>
              <span *ngIf="!isEtaArrived(currentOrder) && !isEtaStaging(currentOrder) && !isEtaNone(currentOrder)"
                >-</span
              >
            </div>
            <div class="driver-status">
              <span *ngIf="!currentOrder?.loaded">EST. PICKUP</span>
              <span *ngIf="currentOrder?.loaded">EST. DROPOFF</span>
            </div>
          </ng-container>
          <div
            class="action-needed"
            *ngIf="currentOrder?.user?.userStatus?.type === 'ActionNeeded' && !currentOrder?.isPreLoad"
          >
            Action Needed
          </div>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="editAndVerify"></ng-container>
    </div>
    <div
      class="info-container exceptionMessage"
      *ngIf="isInProgressGroup(currentOrder) && currentOrder?.user?.userStatus?.isException"
    >
      <div class="title red-text">
        <img src="/assets/icons/alarm-24.svg" alt="Alert" />
        <h2>{{ currentOrder?.user?.userStatus?.exceptionTitle }}</h2>
      </div>
      <div class="content-detail">
        <ng-container>
          {{ currentOrder?.user?.userStatus?.exceptionDescription }}
        </ng-container>
      </div>
      <div class="button-wrap row-reverse" *saAllowedAccountRoles="[1, 2, 9, 10]">
        <a
          *ngIf="currentOrder?.user?.userStatus?.exceptionUrl"
          href="{{ currentOrder?.user?.userStatus?.exceptionUrl }}"
          target="_blank"
        >
          <button mat-stroked-button color="primary">View Steps <i class="material-icons">arrow_forward</i></button>
        </a>
        <a href="tel:{{ currentOrder?.user?.phone }}">
          <button mat-stroked-button color="primary">Call Driver</button>
        </a>
      </div>
    </div>
    <div class="order-detail-content" *ngIf="currentOrder?.user && isComplete(currentOrder)">
      <h3>Load Details</h3>
      <div class="item-row">
        <div class="label">Driver</div>
        <div class="value-wrap">
          {{ currentOrder?.user?.name || '-' }}
        </div>
      </div>
      <div class="item-row">
        <div class="label">Truck</div>
        <div class="value-wrap">{{ currentOrder?.truck?.name || '-' }}</div>
      </div>
      <div class="item-row">
        <div class="label">Ticket Number</div>
        <div class="value-wrap">{{ currentOrder?.ticketNumber || '-' }}</div>
      </div>
      <div class="item-row">
        <div class="label">BOL Number</div>
        <div class="value-wrap">{{ currentOrder?.bolNumber || '-' }}</div>
      </div>
      <div class="item-row">
        <div class="label">Description</div>
        <div class="value-wrap">{{ currentOrder?.description || '' }}</div>
      </div>
      <div class="item-row" *ngIf="!currentOrder?.boxes">
        <div class="label">Load Weight</div>
        <div class="value-wrap">{{ currentOrder?.actualLoadWeight || '-' }}</div>
      </div>
      <div class="item-row" *ngIf="!currentOrder?.boxes">
        <div class="label">Bulk Storage Number</div>
        <div class="value-wrap">{{ currentOrder?.bulkStorageNumber || '-' }}</div>
      </div>

      <ng-container *ngIf="currentOrder?.boxes">
        <div *ngFor="let box of currentOrder?.boxes; let i = index; trackBy: trackById">
          <div class="item-row">
            <div class="label">Box {{ i + 1 }} ID</div>
            <div class="value-wrap">{{ box.name || '-' }}</div>
          </div>

          <div class="item-row">
            <div class="label">Box {{ i + 1 }} Load Weight</div>
            <div class="value-wrap">{{ box.actualLoadWeight || '-' }}</div>
          </div>
        </div>

        <div class="item-row">
          <div class="label">Total Load Weight</div>
          <div class="value-wrap">{{ (getTotalLoadWeight() | async) || '-' }}</div>
        </div>
      </ng-container>

      <ng-container *ngTemplateOutlet="editAndVerify"></ng-container>
    </div>
    <div
      class="info-container"
      *ngIf="
        currentOrder &&
        currentOrder.purchaseOrder &&
        currentOrder.purchaseOrder.uploadedFiles &&
        currentOrder.purchaseOrder.uploadedFiles.length > 0
      "
    >
      <h3>PO Attachments</h3>
      <mat-grid-list cols="2" rowHeight="3:2">
        <mat-grid-tile *ngFor="let file of currentOrder.purchaseOrder.uploadedFiles; trackBy: trackById">
          <div class="image-preview">
            <img [src]="file.url" *ngIf="isImage(file.fileName); else noPreview" (click)="openInWindow(file.url)" />
            <ng-template #noPreview>
              <div class="preview-placeholder" (click)="openInWindow(file.url)">
                <h3>{{ file.fileName }}</h3>
              </div>
            </ng-template>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </ng-container>
  <div
    class="info-container"
    *ngIf="currentOrder?.user && (isInProgressGroup(currentOrder) || isCompleteGroup(currentOrder))"
  >
    <div class="head-wrap">
      <h3>Attachments</h3>
    </div>
    <div class="item-row">
      <div class="label">Upload BOL</div>
      <div *saAllowedAccountRoles="['admin', 'dispatcher', 'default', 'sandCoordinator']">
        <label class="attachment-label">
          <input
            type="file"
            (change)="onFileChange($event, currentOrder?.id, 'bol_image')"
            accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
          />
          <i class="material-icons upload-icon" *ngIf="uploading === ''">
            cloud_upload
          </i>
          <mat-spinner *ngIf="uploading === 'bol_image'" [diameter]="25"></mat-spinner>
        </label>
      </div>
    </div>
    <div class="attachment-row" *ngIf="bolAttachments.length">
      <div
        *ngFor="let file of bolAttachments; trackBy: trackById"
        class="file-preview"
        (click)="downloadFile(file)"
        [ngClass]="{ selected: selectedFileName === file.fileName }"
      >
        <i
          class="material-icons delete-icon"
          (click)="deleteFile(file, $event)"
          *saAllowedAccountRoles="['admin', 'dispatcher', 'default', 'sandCoordinator']"
          >close</i
        >
        <img [src]="getFileIcon(file.fileName)" alt="" />
        <p>{{ smallFileName(file.fileName) }}</p>
      </div>
    </div>
    <div class="item-row">
      <div class="label">Upload Truck Ticket</div>
      <div *saAllowedAccountRoles="['admin', 'dispatcher', 'default', 'sandCoordinator']">
        <label class="attachment-label">
          <input
            type="file"
            (change)="onFileChange($event, currentOrder?.id, 'ticket_image')"
            accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
          />
          <i class="material-icons upload-icon" *ngIf="uploading === ''">
            cloud_upload
          </i>
          <mat-spinner *ngIf="uploading === 'ticket_image'" [diameter]="25"></mat-spinner>
        </label>
      </div>
    </div>
    <div class="attachment-row" *ngIf="truckTicketAttachments.length">
      <div
        *ngFor="let file of truckTicketAttachments; trackBy: trackById"
        class="file-preview"
        (click)="downloadFile(file)"
        [ngClass]="{ selected: selectedFileName === file.fileName }"
      >
        <i
          class="material-icons delete-icon"
          (click)="deleteFile(file, $event)"
          *saAllowedAccountRoles="['admin', 'dispatcher', 'default', 'sandCoordinator']"
          >close</i
        >
        <img [src]="getFileIcon(file.fileName)" alt="" />
        <p>{{ smallFileName(file.fileName) }}</p>
      </div>
    </div>
    <div class="item-row">
      <div class="label">Upload Other</div>
      <div *saAllowedAccountRoles="['admin', 'dispatcher', 'default', 'sandCoordinator']">
        <label class="attachment-label">
          <input
            type="file"
            (change)="onFileChange($event, currentOrder?.id, 'other_image')"
            accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
          />
          <i class="material-icons upload-icon" *ngIf="uploading === ''">
            cloud_upload
          </i>
          <mat-spinner *ngIf="uploading === 'other_image'" [diameter]="25"></mat-spinner>
        </label>
      </div>
    </div>
    <div class="attachment-row" *ngIf="otherAttachments.length">
      <div
        *ngFor="let file of otherAttachments; trackBy: trackById"
        class="file-preview"
        (click)="downloadFile(file)"
        [ngClass]="{ selected: selectedFileName === file.fileName }"
      >
        <i
          class="material-icons delete-icon"
          (click)="deleteFile(file, $event)"
          *saAllowedAccountRoles="['admin', 'dispatcher', 'default', 'sandCoordinator']"
          >close</i
        >
        <img [src]="getFileIcon(file.fileName)" alt="" />
        <p>{{ smallFileName(file.fileName) }}</p>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isEditing$ | async">
    <a mat-icon-button aria-label="Back to detail view" [routerLink]="['./']">
      <mat-icon>arrow_back</mat-icon>
    </a>
    <sa-lmo-order-details-edit></sa-lmo-order-details-edit>
  </ng-container>

  <ng-template #editAndVerify>
    <ng-container *saAllowedAccountRoles="[9]">
      <ng-container *saFeatureFlag="'orderVerificationBySandCoordinator'; else editDetailsButton">
        <ng-container *ngIf="!currentOrder.verificationAction; else verificationDetails">
          <div class="button-wrap">
            <a
              mat-raised-button
              [routerLink]="['./']"
              [queryParams]="{ state: 'edit' }"
              *ngIf="isEditable(currentOrder)"
            >
              Edit Details
            </a>
            <div>
              <button style="color:#448aff" mat-raised-button [routerLink]="['./']" [queryParams]="{ state: 'verify' }">
                Verify Load Details
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *saAllowedAccountRoles="[1, 2, 10]">
      <ng-container *ngTemplateOutlet="editDetailsButton"></ng-container>
    </ng-container>
  </ng-template>
  <ng-template #editDetailsButton>
    <div class="button-row" *saAllowedAccountRoles="[1, 2, 9, 10]">
      <a
        mat-raised-button
        [routerLink]="['./']"
        [queryParams]="{ state: 'edit' }"
        *ngIf="isInProgressGroup(currentOrder) || isEditable(currentOrder)"
      >
        Edit Details
      </a>
    </div>
  </ng-template>
  <ng-template #verificationDetails>
    <div *ngIf="currentOrder.verificationAction === 'verify'" class="flex flex-row items-baseline pt-1 verified">
      <i class="material-icons">check_circle</i
      ><span class="italic"
        >Verified {{ currentOrder.verificationTime | standardDate }} by {{ currentOrder.verifiedBy }}</span
      >
    </div>
    <div *ngIf="currentOrder.verificationAction === 'reject'" class="flex flex-row items-baseline pt-1 rejected">
      <i class="material-icons">cancel</i
      ><span class="italic"
        >Rejected {{ currentOrder.verificationTime | standardDate }} by {{ currentOrder.verifiedBy }}</span
      >
    </div>
  </ng-template>
</div>

<ng-template #loading>
  <mat-spinner></mat-spinner>
</ng-template>

<ng-template #customerNoteModal>
  <h1 mat-dialog-title>
    We are sorry this order was not completed to your liking. Please help us understand why you rated this driver 1
    star.
  </h1>
  <div mat-dialog-content>
    <mat-form-field class="w-full">
      <textarea matInput [formControl]="customerDriverRatingNote"></textarea>
      <mat-hint>Required, please write at least 10 characters. {{ ratingNoteLength$ | async }} / 10</mat-hint>
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="w-full flex justify-between">
    <button mat-button [mat-dialog-close]="null">Nevermind</button>
    <button mat-button (click)="rateDriver()" cdkFocusInitial>Ok</button>
  </div>
</ng-template>
